import oldDoneIssuesCutoffMutation from '../../../rest/old-done-issues-cutoff-graphql/index.tsx';

export const updateOldDoneIssuesCutoffService = (
	contextPath: string,
	rapidViewId: string,
	oldDoneIssuesCutoff: string,
) => oldDoneIssuesCutoffMutation(contextPath, rapidViewId, oldDoneIssuesCutoff);
